export enum CmpConfigPublisherField {
    STANDARD_PURPOSES = "standardPurposes",
    CUSTOM_PURPOSES = "customPurposes",
}
